<template>
  <div class="breadcrumb" v-if="isShowBreadcrumb">
    <div class="breadcrumb-content">
      <div
        v-for="(item, index) in props.mapRouter ?? []"
        :key="item?.name"
        class="breadcrumb-item"
        :class="{ disabled: item?.disabld }"
      >
        <span
          class="breadcrumb-item-text"
          :class="{ active: item?.name === curActivePath }"
          @click="redirectTo(item?.to, item?.disabld)"
          >{{ item?.name }}</span
        >
        <span class="breadcrumb-icon" v-if="index < props.mapRouter.length - 1">></span>
      </div>
    </div>
    <div class="right-slot">
      <slot name="right"></slot>
    </div>
  </div>
</template>
<script lang="ts" setup>
import { computed } from "vue";
import { useRouter } from "vue-router";
import type { RouteLocationRaw } from "vue-router";
import { useSystemStore } from "@/stores";

// 面包屑受到全局system.store控制，外部可以隐藏，但是切换之后，还要复原
const props = defineProps<{
  mapRouter: { name: string; disabld: boolean; to: RouteLocationRaw }[];
}>();

const router = useRouter();
const systemStore = useSystemStore();
const useSystem = useSystemStore();

// 当前的路径
const curActivePath = computed(() => {
  const _len = props.mapRouter.length;
  if (_len > 1) return (props.mapRouter ?? [])[_len - 1].name;
  return "";
});
const isShowBreadcrumb = computed(() => systemStore.isShowBreadcrumb);

// 跳转其他
const redirectTo = (to: RouteLocationRaw, disabld: boolean) => {
  if (to === "/") {
    useSystem.toggleNavPath(to);
  }
  if (disabld) return;
  router.push(to);
};
</script>
<style lang="less" scoped>
.breadcrumb {
  height: 72px;
  display: flex;
  justify-content: space-between;
  align-items: end;
  .breadcrumb-content {
    margin-bottom: 14px;
    display: flex;
    align-items: center;
    font-size: 14px;
    font-weight: 400;
    color: #999999;
    line-height: 18px;
    .breadcrumb-item.disabled {
      cursor: not-allowed;
      .breadcrumb-item-text {
        color: @liner-text-color;
        pointer-events: none;
      }
    }
    .breadcrumb-item-text {
      cursor: pointer;
      transition: all 0.2s;
      &.active {
        color: #333333;
        cursor: default;
      }
    }
    .breadcrumb-item-text:hover {
      color: #333333;
    }
    .breadcrumb-icon {
      margin: 0 8px;
    }
  }
  .right-slot {
    padding-bottom: 2px;
  }
}
</style>
